import React from "react";
import TailwindPageWrapper from "../components/generic/TailwindPageWrapper";
import Hero from "../components/generic/Hero";
import SponsoringBenefits from "../components/sponsorDetailsPage/SponsoringBenefit";
import PrivateDonation from "../components/sponsorDetailsPage/PrivateDonation";
import SponsoringComparison from "../components/sponsorDetailsPage/SponsoringComparison";

function SponsorDetailsPage() {
  return (
    <TailwindPageWrapper>
      <div className="-mt-24">
        <Hero
          className="hero-sponsors"
          site_call="sponsors_details_page"
          next_section="sponsoring-benefits"
        />
        <SponsoringBenefits />
        <PrivateDonation />
        <SponsoringComparison />
      </div>
    </TailwindPageWrapper>
  );
}

export default SponsorDetailsPage;
